// extracted by mini-css-extract-plugin
module.exports = {"controls":"PostControls_controls__DC257","icons":"PostControls_icons__1Y79d"};